<div class="dds-modal-overlay" (click)="close()"></div>
<ng-content></ng-content>
